export default function () {
    const entityDancer = useEntityDancer();

    async function get(filter) {
        let dancers = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('dancers', filter);
            dancers = data.dancers.map((dancer) => {
                return entityDancer.build(dancer);
            });
        } catch (e) {
            error = useApiError(e);
        }
        return {dancers, error};
    }

    return {get};
}
